import { handleJSON } from '@/utils/fetch-utils';
import { CLASS_TYPES, LIVE_INSTRUCTION_CLASS_TYPES, USER_ROLES } from '@/constants';
import { headers, uploadFileHeaders } from './index';

const { API_URL, LIVE_INSTRUCTION_API_URL } = process.env;

export default {
  endpoints: {
    classDetail: (id, type) =>
      `${LIVE_INSTRUCTION_API_URL}/v0/teacher/calendar/classes/${id}?webackend_class_type=${LIVE_INSTRUCTION_CLASS_TYPES[type]}`,
    updateClass: (id, userRole, classType) =>
      `${LIVE_INSTRUCTION_API_URL}/v0/${userRole}/calendar/classes/${id}/update?webackend_class_type=${LIVE_INSTRUCTION_CLASS_TYPES[classType]}`,
    uploadClasses: `${API_URL}/classes/group/bulk/`,
    savePrivateClassFeedback: classUuid =>
      `${LIVE_INSTRUCTION_API_URL}/v0/teacher/calendar/feedback/1-1/${classUuid}/save`,
    submitPrivateClassFeedback: classId => `${LIVE_INSTRUCTION_API_URL}/v0/teacher/calendar/feedback/1-1/${classId}`,
    validateResource: resourceId => `${API_URL}/validate_resource/?resource_id=${resourceId}`,
    learnerAssessment: (learnerId, assessmentId) =>
      `${API_URL}/users/${learnerId}/assessment-progresses/${assessmentId}/`,
    refundClass: classUuid => `${LIVE_INSTRUCTION_API_URL}/v0/admin/calendar/classes/${classUuid}/refund`,
  },

  fetchClassDetail({ id, type }) {
    const endpoint = this.endpoints.classDetail(id, type);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchLearnerAssessment(learnerId, assessmentId) {
    const endpoint = this.endpoints.learnerAssessment(learnerId, assessmentId);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  cancelGroupClass(id) {
    const endpoint = this.endpoints.classDetail(id, CLASS_TYPES.GROUP);

    const options = {
      method: 'DELETE',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  cancelPrivateClass(id) {
    const endpoint = this.endpoints.classDetail(id, CLASS_TYPES.PRIVATE);

    const options = {
      method: 'DELETE',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  savePrivateClassFeedback(id, feedbackData) {
    const endpoint = this.endpoints.savePrivateClassFeedback(id);
    const options = {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(feedbackData),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  submitPrivateClassFeedback(classId, feedbackData) {
    const endpoint = this.endpoints.submitPrivateClassFeedback(classId);
    const options = {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(feedbackData),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  getUserRole(classData) {
    const fieldsBeingUpdated = Object.keys(classData);
    const isLessonUpdateRequest =
      fieldsBeingUpdated.length === 2 &&
      fieldsBeingUpdated.includes('id') &&
      fieldsBeingUpdated.includes('course_code');
    if (isLessonUpdateRequest) {
      return USER_ROLES.TEACHER;
    }
    return USER_ROLES.ADMIN;
  },

  saveGroupClass(classData) {
    const { id } = classData;
    const userRole = this.getUserRole(classData);
    const endpoint = this.endpoints.updateClass(id, userRole, CLASS_TYPES.GROUP);
    const updatedClassData = userRole === USER_ROLES.ADMIN ? { ...classData, skip_back_dual_write: false } : classData;
    const options = {
      method: 'PATCH',
      headers: headers(),
      body: JSON.stringify(updatedClassData),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  savePrivateClass(classData) {
    const { id } = classData;
    const endpoint = this.endpoints.updateClass(id, USER_ROLES.TEACHER, CLASS_TYPES.PRIVATE);

    const options = {
      method: 'PATCH',
      headers: headers(),
      body: JSON.stringify(classData),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  uploadClasses({ file }) {
    const endpoint = this.endpoints.uploadClasses;
    const formData = new FormData();
    formData.append('csv_file', file);

    const options = {
      method: 'POST',
      headers: uploadFileHeaders(),
      body: formData,
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  validateLesson(resourceId) {
    const endpoint = this.endpoints.validateResource(resourceId);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  refundClass(classUuid) {
    const endpoint = this.endpoints.refundClass(classUuid);
    const options = {
      method: 'POST',
      headers: headers(),
    };
    return fetch(endpoint, options).then(handleJSON);
  },
};
